import React from 'react';
import {
    Checkbox,
    FormControlLabel,
    FormControl,
    Typography,
    Paper,
    Button, Backdrop, Stack, NativeSelect, InputLabel, OutlinedInput, Container
} from "@mui/material";
import {MuiTelInput} from "mui-tel-input";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import csLocale from 'date-fns/locale/cs';
//import DateFNSUtils from '@date-io/date-fns';
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFnsV3";
import addYear from 'date-fns/addYears';
import Moment from 'moment';
//import 'react-phone-input-2/dist/style.css';
import RegFormPopUp from "./RegFormPopUp";
/*import LoadingOverlay from 'react-loading-overlay';*/
import CircularProgress from "@mui/material/CircularProgress";
import qs from 'query-string';
import apiHelper from './ApiHelper'
import moment from "moment";
import {addDays, parse} from "date-fns";

export default class RegistrationForm extends React.Component {

    constructor(props) {
        super(props);
        //this.setState({maxDate:addDay(Date.now(),-18)});
        //this.state =  {birthDay: format(addYear(Date.now(),-18),'dd.mm.yyy')};
        const now = new Date()
        this.state = {
            birthDay: addYear(Date.now(), -18),
            phone: "+420",
            agreement: true,
            requestDate: (new Date()).getDay() === 6
                ? addDays(now, 2)
                : now.getDay() === 0
                    ? addDays(now, 1)
                    : now,
            open: false,
            stateValues: ["firstName", "lastName", "phone", "agreement", "FormattedRequestDate", "Note", "SelectedTime", "FormattedBirthDay"],
            firstName: "",
            lastName: "",
            Note: "",
            AvailableHours: [],
            SelectedTime: "",
            FormattedRequestDate: "",
            FormattedBirthDay: "",
            PDFURL: "",
            dialogTitle: "",
            dialogBody: "",
            ShowLoadingBar: false,
            submitAction: "insertReservation",
            updateAction: "updateReservation",
            editedUserID: "",
            dialogCallback: null,
            RootURL: apiHelper.GetRootUrlWithCurrentDomain(),
            ApiURL: apiHelper.GetUrlWithCurrentDomain("wp-json/reservation-plugin/controller"),
            CallbackURLAdmin: apiHelper.GetUrlWithCurrentDomain("?edit=1"),
            OriginSelectedTime: "",
            DownloadEditedData: false,
        };
        console.log(this.state.RootURL);
        console.log("program začal");
        console.log(this.state.RootURL);
        this.GdprDialogTitle = "Souhlas s GDPR";
        this.GdprDialogBody = "Pro dokončení objednání musíte souhlasit se zpracováním osobních údajů.";
        this.dialogRef = React.createRef();
        this.GDPR = React.createRef();
        this.TimeLimit = 5000;


        this.handleDate = this.handleDate.bind(this);
        this.handlePhoneNumber = this.handlePhoneNumber.bind(this);
        this.handleAgreement = this.handleAgreement.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.openModal = this.openModal.bind(this);
        this.handleFirstName = this.handleFirstName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.processForm = this.processForm.bind(this);
        this.handleNote = this.handleNote.bind(this);
        this.DownloadTimes = this.DownloadTimes.bind(this);
        this.handleSelectedTime = this.handleSelectedTime.bind(this);
        this.UserAgreeWithGDPR = this.UserAgreeWithGDPR.bind(this);
        this.OnError = this.OnError.bind(this);


        //this.DownloadTimes();
        Moment.locale('cs-CZ');
    }

    componentDidMount() {
        //const queryString = require('query-string');
        this.DownloadPDFURL();
        this.DownloadAndInitEdit(qs.parse(window.location.search).henry);
        this.setState({
            //RootURL: "https://" + window.location.hostname,
            // ApiURL: this.state.RootURL + "/wp-json/reservation-plugin/controller",
            CallbackURLAdmin: apiHelper.GetUrlWithCurrentDomain("prehled-rezervaci"),
            FormattedRequestDate: new Moment(this.state.requestDate).format("DD.MM.YYYY")
        }, () => {
            console.log(this.state.RootURL);
        });
        console.log(this.state.phone);
    }


    DownloadAndInitEdit(value) {
        console.log("volám DownloadAndInitEdit", value);
        this.ExecuteMethodWithTimeout(() => {
            if (this.state.DownloadEditedData === true) {
                return;
            }
            if (typeof (value) !== 'undefined' || value != null && value !== "") {

                this.setState({editedUserID: value});
                this.state.ShowLoadingBar = true;
                let formData = new FormData();
                formData.append("action", "getUserByID");
                formData.append("id", value);
                fetch(this.state.ApiURL, {
                    method: 'post',
                    body: formData
                }).then(response => {
                    if (response.ok)
                        return response.json();
                    else
                        throw new Error("nastala chyba");
                }).then(data => {
                    return JSON.parse(data);
                }).then(data => {
                    console.log("stažená data:");
                    console.log(data);
                    console.log("konec stažených dat");
                    for (let key in data) {
                        console.log(key + ": " + data[key]);
                        if (key === "SelectedTime") {
                            this.setState({OriginSelectedTime: data[key]});
                            this.setState({[key]: data[key]});
                        } else {
                            this.setState({[key]: data[key]});
                        }
                    }

                    setTimeout(() => {
                        this.setState({
                            submitAction: this.state.updateAction,
                            // OriginSelectedTime: this.state.SelectedTime,
                            DownloadEditedData: true,
                        });
                    }, 200);

                    this.InitFormatedToUnFormatted();
                }).catch(error => {
                    console.log(error);
                    this.OnError();
                });
            } else {
                this.DownloadTimes();
            }
        }, this.TimeLimit);
    }

    InitFormatedToUnFormatted() {
        setTimeout(() => {
            this.setState({
                birthDay: parse(this.state.FormattedBirthDay, "dd.MM.yyyy", new Date()),
                requestDate: parse(this.state.FormattedRequestDate, "dd.MM.yyyy", new Date())
            }, () => {
                this.DownloadTimes();
            });
        }, 200);
    }

    DownloadTimes() {
        this.ExecuteMethodWithTimeout(() => {
            console.log("Stahuji časy pro datum: " + this.state.requestDate);
            this.state.ShowLoadingBar = true;
            const formData = new FormData();
            formData.append("action", "getDateInterval");
            formData.append("date", new Moment(this.state.requestDate).format("DD.MM.YYYY"));
            formData.append("ignoreCondition", this.state.action === this.state.updateAction ? "1" : "0");
            fetch(this.state.ApiURL, {
                method: 'post',
                body: formData
            }).then(response => {
                console.log(response)
                if (response.ok)
                    return response.json();
                else
                    throw new Error("nastala chyba");
            }).then((data) => {
                return data;
            }).then(data => {

                const availableHours = JSON.parse(data);

                if (availableHours.length > 0) {
                    this.setState({
                        AvailableHours: availableHours,
                    }, () => {
                        this.setState({SelectedTime: this.state.AvailableHours[0]});
                    });
                } else {
                    this.setState({AvailableHours: ["Není dostupný žádný termín"]}, () => {
                        this.setState({SelectedTime: this.state.AvailableHours[0]});
                    });
                }

            }).catch(error => {
                console.log("nastala chyba" + error);
                this.OnError();
            });
        }, this.TimeLimit);

    }

    ExecuteMethodWithTimeout(method, timeout) {
        //    console.log(method);
        const caller = setTimeout(function () {
                this.onError();
            }.bind(this), timeout
        );
        method();
        clearTimeout(caller);
        this.setState({ShowLoadingBar: false});
    }

    OnError() {
        this.setState({ShowLoadingBar: false});
        this.OpenDialog("Objednávání momentálně není dostupné. Prosím zkuste to později, nyní budete přesměrováni na úvodní stranu.", "Něco se pokazilo", () => {
            window.location = this.state.RootURL;
        }, "ROZUMÍM");


    }

    DownloadPDFURL() {
        const formData = new FormData();
        formData.append("action", "getGDPR");
        this.ExecuteMethodWithTimeout(() => {
            fetch(this.state.ApiURL, {
                method: 'post',
                body: formData
            }).then(response => {
                if (response.ok)
                    return response.json();
                else
                    throw new Error("nastala chyba");
            }).then(data => {
                return data;
            }).then(data => {
                this.setState({PDFURL: decodeURIComponent(data).replace('"', '')});
            }).catch(error => {
                console.error("nastala chyba " + error.message);
                this.OnError();
            });
        }, this.TimeLimit);
    }


    handleSelectedTime(eventItem) {
        this.setState({SelectedTime: eventItem.target.value})
    }

    handleNote(note) {
        this.setState({Note: note.target.value});
    }

    handleFirstName(name) {
        this.setState({firstName: name.target.value});
    }

    handleLastName(name) {
        this.setState({lastName: name.target.value});
    }

    handleDate(date) {
        console.log(date);
        console.log("bday: " + new Moment(this.state.birthDay).format("DD.MM.YYYY"));
        this.setState({birthDay: Moment(date)}, () => {
            this.setState({FormattedBirthDay: new Moment(this.state.birthDay).format("DD.MM.YYYY")});
        });
    }

    handleRequestDate(date) {
        this.setState({requestDate: Moment(date)}, () => {
            this.DownloadTimes();
            this.setState({SelectedTime: ""});
            this.setState({FormattedRequestDate: new Moment(this.state.requestDate).format("DD.MM.YYYY")});
        });
    }

    handlePhoneNumber(phoneNumber, eventObject) {
        this.setState({phone: phoneNumber, phoneWasChanged: true});
    }

    handleAgreement(event) {
        this.setState({agreement: event.target.checked});
    }

    disableWeekends(date) {
        var day = moment(date);
        return day.day() === 0 || day.day() === 6;
    }

    openModal() {
        this.setState({open: true, agreement: true});
    }

    closeModal() {
        this.setState({open: false});
    }

    UserAgreeWithGDPR() {
        this.setState({agreement: true}, () => {
            this.processForm(null);
        });
    }

    openGDPRDialog() {
        this.setState({
            dialogTitle: this.GdprDialogTitle,
            dialogBody: this.GdprDialogBody
        });
        this.dialogRef.current.Open();
    }

    processForm(event) {
        if (event != null)
            event.preventDefault();
        let result = {};

        this.state.stateValues.forEach(item => {
            console.log("item: " + item + "value: " + this.state[item]);
            result[item] = this.state[item];
        });
        if (this.state.agreement !== true) {
            this.OpenDialog(this.GdprDialogBody, this.GdprDialogTitle, this.UserAgreeWithGDPR)
            return;
        }
        if (this.state.submitAction === this.state.updateAction) {
            result["id"] = this.state.editedUserID;
        }

        let formData = new FormData();
        formData.append("action", this.state.submitAction);
        formData.append("user", JSON.stringify(result));
        fetch(this.state.ApiURL, {
            method: 'post',
            body: formData
        }).then(response => {
            if (response.ok)
                return response.json();
            else
                throw new Error("nastala chyba");
        }).then(data => {
            console.log(data);

            let responseCode = parseInt(data);
            if (responseCode === 1) {
                this.OpenDialog("", "Akce proběhla úspěšně", () => {
                    this.setState({
                        open: false
                    });
                    if (this.state.submitAction === this.state.updateAction)
                        window.location = this.state.CallbackURLAdmin;
                    else
                        window.location = this.state.RootURL;
                }, "OK");
            } else
                alert("neco se pokazilo");
        }).catch(error => {
            console.error("nastala chyba: " + error.message);
            this.OnError();
        });
    }


    OpenDialog(_dialogBody, _dialogTitle, _callback, _dialogBtnAgreeText = "SOUHLASÍM") {
        this.setState({
            dialogTitle: _dialogTitle,
            dialogBody: _dialogBody,
            dialogCallback: _callback
        }, () => {
            if (this.dialogRef.current !== null) {
                this.dialogRef.current.Open(this.state.dialogBody, this.state.dialogTitle, _dialogBtnAgreeText);
            }
        });
    }

    render() {

        return (
            <Container maxWidth="md">
                <Backdrop
                    sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
                    open={this.state.ShowLoadingBar}
                >
                    <CircularProgress color="inherit"/>
                </Backdrop>
                <div>
                    <RegFormPopUp ref={this.dialogRef} AgreementCallback={this.state.dialogCallback}/>
                    <form onLoad={this.DownloadTimes} onSubmit={this.processForm} style={{fontSize: "18px"}}>
                        <Stack spacing={2}>

                            <FormControl fullWidth>
                                <InputLabel shrink htmlFor="FirstName">Jméno</InputLabel>
                                <OutlinedInput
                                    id="FirstName"
                                    required
                                    value={this.state.firstName}
                                    onChange={this.handleFirstName}
                                    label="Jméno"
                                />
                            </FormControl>

                            <FormControl fullWidth>
                                <InputLabel shrink htmlFor="LastName">Příjmení</InputLabel>
                                <OutlinedInput
                                    id="LastName"
                                    required
                                    value={this.state.lastName}
                                    onChange={this.handleLastName}
                                    label="Příjmení"
                                />
                            </FormControl>

                            <MuiTelInput
                                id="PhoneNumber"
                                value={this.state.phone ?? "+420"}
                                onChange={this.handlePhoneNumber}
                                country="cz"
                                defaultCountry="cz"
                                label="Zadejte své telefonní číslo"
                                required
                                margin="normal"
                                variant="outlined" // velmi důležité
                                disableDropdown={false}
                            />

                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={csLocale}>
                                <DatePicker
                                    disablePast={false}
                                    label="Datum narození"
                                    value={this.state.birthDay}
                                    onChange={(event) => this.handleDate(event)}
                                    slotProps={{textField: {fullWidth: true, InputLabelProps: {shrink: true}}}}
                                />
                            </LocalizationProvider>

                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={csLocale}>
                                <DatePicker
                                    disablePast={true}
                                    label="Datum objednání"
                                    value={this.state.requestDate}
                                    onChange={(event) => this.handleRequestDate(event)}
                                    shouldDisableDate={this.disableWeekends}
                                    slotProps={{textField: {fullWidth: true, InputLabelProps: {shrink: true}}}}
                                />
                            </LocalizationProvider>

                            <Paper
                                style={{display: (this.state.SelectedTime !== "" && this.state.submitAction === this.state.updateAction) ? "" : "none"}}>
                                <Typography variant="h6" component="h5">Aktuální vybraný čas</Typography>
                                <Typography variant='subtitle2'
                                            gutterBottom>{this.state.OriginSelectedTime}</Typography>
                            </Paper>

                            <FormControl fullWidth variant={"outlined"}>
                                <InputLabel shrink htmlFor="SelectedTime">Vyberte čas</InputLabel>
                                <NativeSelect
                                    id="SelectedTime"
                                    required
                                    value={this.state.SelectedTime.toString()}
                                    /*onChange={this.handleSelectedTime}*/
                                    variant={"outlined"}
                                    input={<OutlinedInput notched onChange={this.handleSelectedTime}
                                                          label="Vyberte čas"/>}
                                >
                                    {this.state.AvailableHours.map((item, key) => (
                                        <option key={key} value={item}>{item}</option>
                                    ))}
                                </NativeSelect>
                            </FormControl>

                            <FormControl fullWidth>
                                <InputLabel shrink htmlFor="Note">Poznámka</InputLabel>
                                <OutlinedInput
                                    id="Note"
                                    multiline
                                    rows={4}
                                    value={this.state.Note}
                                    onChange={this.handleNote}
                                    label="Poznámka"
                                />
                            </FormControl>

                            <FormControlLabel
                                style={{display: (this.state.submitAction === this.state.updateAction) ? "none" : ""}}
                                ref={this.GDPR}
                                control={<Checkbox checked={this.state.agreement} onChange={this.handleAgreement}/>}
                                label={
                                    <Typography>Souhlasím s <a href={this.state.PDFURL} target="_blank"
                                                               rel="noopener noreferrer">podmínkami</a></Typography>
                                }
                            />

                            <Button type="submit" color="primary" variant="contained">Rezervovat</Button>

                        </Stack>
                    </form>
                </div>
            </Container>
        );
    }
}
